'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHide = exports.shouldShow = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createConditional = require('./createConditional');

var _createConditional2 = _interopRequireDefault(_createConditional);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayName = 'Action';

var propTypes = {
  hide: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  show: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string])
};

var matches = function matches(value, actions) {
  return Array.isArray(value) ? actions.some(function (action) {
    return value.includes(action);
  }) : actions.includes(value);
};

var shouldShow = exports.shouldShow = function shouldShow(props, context) {
  return matches(props.show, context.actions);
};

var shouldHide = exports.shouldHide = function shouldHide(props, context) {
  return props.hide ? matches(props.hide, context.actions) : !matches(props.show, context.actions);
};

exports.default = (0, _createConditional2.default)({
  displayName: displayName,
  propTypes: propTypes,
  shouldShow: shouldShow,
  shouldHide: shouldHide
});


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/Action.js
// module id = 1169
// module chunks = 168707334958949